import FamilyWizardLayout from '@/app/pages/family_application/FamilyWizardLayout.tsx'
import { Button, buttonVariants } from '@/common/components/Button'
import { InformationIcon, PencilIcon } from '@/common/icons/general'
import { AppRoutePaths } from '@/routing/route_paths'
import { RefreshFamilyApplication } from '@/storage/applications/familyApplicationSlice'
import { selectProgramID } from '@/storage/program_settings/programSettingsSlice'
import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { SkipVerification } from './skip-verification/SkipVerification'
import { AppDispatch } from '@/storage/store'
import { LogUserActivity } from '@/apis/users/requests'
import { LOG_TYPES } from '../constants'

export const IncomeHomePage = () => {
  const { t: translate } = useTranslation()
  const [skip, setSkip] = useState(false)
  const navigateTo = useNavigate()
  const dispatch = useDispatch<AppDispatch>()
  const programId = useSelector(selectProgramID)

  const hasLoggedPageView = useRef(false);
  useEffect(() => {
    dispatch(RefreshFamilyApplication(programId))
    if (!hasLoggedPageView.current) {
      LogUserActivity({
        log_type: LOG_TYPES.VIEW_PAGE,
        suffix_text: 'Income verification page',
      })
      hasLoggedPageView.current = true;
    }
  }, [])

  if (skip)
    return (
      <SkipVerification
        onCancel={() => {
          setSkip(false)
        }}
      />
    )

  return (
    <FamilyWizardLayout>
      <FamilyWizardLayout.Header>
        <h1>{translate('income_verification')}</h1>
      </FamilyWizardLayout.Header>
      <FamilyWizardLayout.Content>
        <section id="income-verification">
          <h2 className="text-xl font-medium text-gray-900 mb-10">
            {translate('determine_application_text')}{' '}
          </h2>
          <ul className="space-y-6">
            <li>
              <h3 className="flex items-center">
                <PencilIcon aria-hidden="true" />
                <span className="ml-2 font-medium">
                  {translate('what_to_expect')}
                </span>
              </h3>
              <p className="ml-6 mt-1 text-gray-700 text-sm">
                {translate('few_questions')}
              </p>
            </li>
            <li>
              <h3 className="flex items-center">
                <InformationIcon aria-hidden="true" />
                <span className="ml-2 font-medium">
                  {translate('what_you_may_need')}
                </span>
              </h3>
              <ul className="text-sm text-gray-700 list-disc list-inside ml-7">
                <li>{translate('social_security_info')}</li>
                <li className="">
                  <span className="">
                    {translate('income_requirements_docs')}{' '}
                    <a
                      className={buttonVariants({
                        variant: 'text',
                        size: 'text',
                        className: 'inline',
                      })}
                      target="_blank"
                      href="https://help.acescholarships.org"
                    >
                      {translate('income_help_link')}
                    </a>
                  </span>
                </li>
              </ul>
            </li>
          </ul>
        </section>
      </FamilyWizardLayout.Content>
      <FamilyWizardLayout.ActionBar>
        <div className="w-full flex flex-col">
          <Button
            onClick={() => {
              navigateTo(
                AppRoutePaths.family_application.income_verification
                  .household_size
              )
            }}
            className="h-9 mb-5"
            aria-label={translate('continue')}
          >
            {translate('continue')}
          </Button>
          <Button
            variant={'text'}
            size={'text'}
            className="text-sm"
            onClick={() => {
              setSkip(true)
            }}
            aria-label={translate('skip_income_verification')}
          >
            {translate('skip_income_verification')}
          </Button>
        </div>
      </FamilyWizardLayout.ActionBar>
    </FamilyWizardLayout>
  )
}
